import { createContext } from 'react';
import { useLocalStorage } from 'react-use';
import { localStorageKeys } from '../config/fapApp.config';
import useCompanyCategory from '../hooks/useCompanyCategory';
import useCompanyLocation from '../hooks/useCompanyLocation';
import useSelectedContractors from '../hooks/useSelectedContractors';
import mapCategoriesToProducts from '../utils/mapCategoriesToProducts';
import { useAnalyticsPushEvent } from '../analytic/analytic.context';

export const FapAppContext = createContext({});

const FapAppProvider = ({ children }) => {
  const pushEvent = useAnalyticsPushEvent();
  const appDrupalSettings = window.drupalSettings.findAProData;
  try {
    if (!appDrupalSettings) {
      throw new Error(
        'The app context requires own data-set with key findAProData in drupalSettings object in the global scope.',
      );
    }
  } catch (er) {
    // eslint-disable-next-line no-console
    console.error(er);
  }
  const { savedCategory, setSavedCategory } = useCompanyCategory(
    localStorageKeys.productCategory,
  );
  const { savedLocation, setSavedLocation } = useCompanyLocation(
    localStorageKeys.geoData,
  );
  const [savedFilters, setSavedFilters] = useLocalStorage(
    localStorageKeys.savedFilters,
  );
  const { agentServices, qualifications } = appDrupalSettings;
  const categories =
    appDrupalSettings?.settings?.product_options_to_agent_services;
  const commonSettings = appDrupalSettings?.settings;
  const algoliaSettings = appDrupalSettings?.algolia_settings;
  const { contractorsTray, setContractorsTray } = useSelectedContractors(
    localStorageKeys.contractorsTray,
    agentServices,
    qualifications,
    savedLocation,
    algoliaSettings.algolia_index,
  );
  const addToEstimateAnalytics = (contractorTitle, contentType) => {
    pushEvent({
      event: 'find_a_pro_added_to_estimate',
      event_origin: 'front_end',
      content_type: contentType,
      vendor_name: contractorTitle,
      component_name: 'Get an estimate checkbox',
    });
  };
  const value = {
    qualifications,
    agentServices,
    categories: mapCategoriesToProducts(categories),
    selectedCategory: savedCategory,
    selectedLocation: savedLocation,
    setSelectedLocation: setSavedLocation,
    setSelectedCategory: setSavedCategory,
    contractorsTray,
    setContractorsTray,
    commonSettings,
    algoliaSettings,
    addToEstimateAnalytics,
    savedFilters,
    setSavedFilters,
  };
  return (
    <FapAppContext.Provider value={value}>{children}</FapAppContext.Provider>
  );
};

export default FapAppProvider;
